import track from '../track';
import { EquityType, EventLocation } from '../types';

export const toolsAnalyticsEvents = {
  grantAdded: (): void => track.mixpanel('tools-options-grant-add'),

  /** Equity */
  addEquityClick: (): void => track.mixpanel('tools-add-equity_click'),
  equityAdded: (properties: EquityType): void => {
    track.all<EquityType>('tools-equity_added', properties);
  },

  /** Company */
  addCompanyClicked: (properties: EventLocation): void =>
    track.mixpanel<EventLocation>('tools-add-company_clicked', properties),
  companyAdded: (): void => track.mixpanel('tools-company_added'),
  addCompanyFailed: (): void => track.mixpanel('tools-add-company_failed'),

  /** Property */
  addPropertyClicked: (): void => track.mixpanel('tools-add-real-estate-property_clicked'),
  propertyAdded: (): void => {
    track.mixpanel('tools-add-real-estate-property_added');
  },
  addPropertyFailed: (): void => track.mixpanel('tools-add-real-estate-property_failed'),
  propertyViewed: (): void => track.mixpanel('tools-real-estate-property_viewed'),
};
